import React, { useEffect, useState } from "react";
import "./LandingPage.css";
import InputBox from "../../../components/reusable-input/InputBox";
import Button from "../../../components/reusable-button/Button";
import {
  createLandingPage,
  updateLandingPage,
  listLandingPages,
} from "../../../apis/landingPageApi";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../../redux/slices/snackbarSlice";
import { RootState } from "../../../redux/store/store";
import {
  setLandingPageData,
  setLandingPageNeedRefresh,
} from "../../../redux/slices/landingPageSlice";
import ReusableLoader from "../../../components/reusable-loader/ReusableLoader";

const LandingPage: React.FC = () => {
  const landingPage = useSelector((state: RootState) => state.landingPage);
  const [description, setDescription] = useState(landingPage.description);
  const [youtubeUrl, setYoutubeUrl] = useState(landingPage.contentUrl);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);

  const dispatch = useDispatch();

  const adminDetail = localStorage.getItem("adminDetail");
  const roleName = adminDetail
    ? JSON.parse(adminDetail)?.roleIds?.roleName
    : null;

  useEffect(() => {
    const fetchLandingPage = async () => {
      try {
        const res = await listLandingPages();
        if (res.success && res.data.length > 0) {
          const page = res.data[0];
          dispatch(
            setLandingPageData({
              id: page.id,
              description: page.description,
              contentUrl: page.contentUrl,
            })
          );
          setDescription(page.description);
          setYoutubeUrl(page.contentUrl);
        }
      } catch (error) {
        console.error("Error fetching landing page", error);
        dispatch(
          showSnackbar({
            message: "Failed to load landing page.",
            type: "error",
          })
        );
      } finally {
        setLoading(false);
      }
    };

    if (landingPage.needRefresh) {
      fetchLandingPage();
    } else {
      setDescription(landingPage.description);
      setYoutubeUrl(landingPage.contentUrl);
      setLoading(false);
    }
  }, [landingPage.needRefresh]);

  const handleSave = async () => {
    if (!description.trim()) {
      dispatch(
        showSnackbar({
          message: "Description is required.",
          type: "error",
        })
      );
      return;
    }

    if (!youtubeUrl.trim()) {
      dispatch(
        showSnackbar({
          message: "YouTube URL is required.",
          type: "error",
        })
      );
      return;
    }

    setButtonLoading(true);
    const payload = {
      description,
      contentUrl: youtubeUrl,
    };

    try {
      if (landingPage.id) {
        const response = await updateLandingPage(landingPage.id, payload);
        if (response?.success) {
          dispatch(
            showSnackbar({
              message: response.data || "Landing page updated successfully!",
              type: "success",
            })
          );
          dispatch(setLandingPageNeedRefresh(true));
        }
      } else {
        const response = await createLandingPage(payload);
        if (response?.success) {
          dispatch(setLandingPageNeedRefresh(true));
          dispatch(
            showSnackbar({
              message: "Landing page created successfully!",
              type: "success",
            })
          );
        }
      }
    } catch (error) {
      console.error("Error saving landing page", error);
      dispatch(
        showSnackbar({
          message: "Something went wrong. Please try again.",
          type: "error",
        })
      );
    }
    setButtonLoading(false);
  };

  if (loading)
    return (
      <div>
        <ReusableLoader />
      </div>
    );

  return (
    <div className="landing-wrapper">
      <h2>Landing Page</h2>

      <label className="input-label">
        Description <span className="required">*</span>
      </label>
      <textarea
        className="textarea"
        required
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Enter description"
        disabled={roleName === "admin"}
      />

      <InputBox
        label="Enter YouTube URL"
        required
        placeholder="Enter YouTube URL"
        value={youtubeUrl}
        onChange={(e) => setYoutubeUrl(e.target.value)}
        disabled={roleName === "admin"}
      />
      {roleName !== "admin" && (
        <div className="btn-row">
          {/* <div className="btn-left">
            <Button
              label="Cancel"
              variant="outlined"
              onClick={() => {
                setYoutubeUrl("");
              }}
            />
          </div> */}
          <div className="btn-right">
            <Button
              label="Save Changes"
              onClick={handleSave}
              loading={buttonLoading}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
